import styled, { keyframes } from "styled-components"
import { overloadColor } from "../../util/style"

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

const tailAnimation = keyframes`
  0% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  5%,
  95% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  10%,
  59% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;
  }
  20% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;
  }
  38% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;
  }
  100% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
`
interface SpinnerTailProps {
  size: number
  colorPrimary: string
  duration: number
}
export const SpinnerTail = styled.div<SpinnerTailProps>`
  position: relative;

  width: ${(props) => props.size / 1.65}px;
  height: ${(props) => props.size / 1.65}px;
  margin-top: 8px;
  border-radius: 50%;

  color: ${(props) => overloadColor(props.colorPrimary)};
  font-size: ${(props) => props.size / 1.65}px;
  text-indent: -9999em;
  overflow: hidden;

  transform: translateZ(0);
  animation: ${tailAnimation} ${(props) => props.duration}s infinite ease,
    ${rotateAnimation} ${(props) => props.duration}s infinite ease;
`
